/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useContext } from "react";
import { openDB } from "idb";
import { constrainLength, constrainLineLengths } from "../utils/form";
import SetupModal from "./SetupModal";
import InvoiceFieldCustomizationForm from "./InvoiceFieldCustomizationForm";
import styles from "../css/SetupForm.module.css";
import PageConfigurationForm from "./PageConfigurationForm";
import axios from "axios";
import Context from "../context/context";
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';

const DEFAULT_INVOICE_SETUP = {
  brand_uuid: "",
  field_values: {
    brand_invoice_logo: "",
    invoice_heading: "",
    invoice_title: "",
    invoice_address: "",
    invoice_phone: "",
    invoice_blank: "",
    invoice_bottomnote: "",
  },
  printer_name: "0",
  invoice_field_customization: {
    seat: "",
    ticket_number: "",
    order_number: "",
    date: "",
    time: "",
    payment_mode: "",
    cashier: "",
    customer_name_dinein: "",
    customer_name_takeaway: "",
    customer_name_delivery: "",
    customer_name_zomato: "",
    customer_mobile_dinein: "",
    customer_mobile_takeaway: "",
    customer_mobile_delivery: "",
    customer_mobile_zomato: "",
    customer_address_dinein: "",
    customer_address_takeaway: "",
    customer_address_delivery: "",
    customer_address_zomato: "",
    serial_number_in_items: "",
    total_item_quantity: "",
    item_display_type: "",
    multi_serving_display: "",
  },
};

const MAX_CHARS = {
  invoice_heading: 15,
  invoice_title: 30,
};

const MESSAGE_LINES = {
  invoice_phone: [3, 15],
  invoice_address: [3, 40],
  invoice_blank: [4, 40],
  invoice_bottomnote: [10, 40],
};

const servers = [
  "http://127.0.0.1:7878",
  "https://api.myfooddo.com/brand",
  // "http://localhost:5000/brand",
]

export default function InvoiceSetupForm({ onSave, currentInvoiceIndex = 0, brand_uuid }) {

  const [invoiceSetup, setInvoiceSetup] = useState(DEFAULT_INVOICE_SETUP);
  const [customizationModalOpen, setCustomizationModalOpen] = useState(false);
  const [pageConfigurationModalOpen, setPageConfigurationModalOpen] = useState(false);
  const [printers, setPrinters] = useState([]);
  const context = useContext(Context);
  const { updateUnSync } = context;

  //Fetching all the existing outlets form indexDB
  useEffect(() => {
    const getData = async () => {
      const db = await openDB('FoodDo', +localStorage.getItem('IDBVersion') || 1);
      const outletStore = db.transaction("outlet", "readonly").objectStore("outlet");
      const currentOutlet = (await outletStore.getAll())[0];
      const dbInvoiceSetup = await currentOutlet.invoice_setup?.find(i => i.brand_uuid === brand_uuid);
      console.log({ brand_uuid, dbInvoiceSetup })
      if (dbInvoiceSetup)
        setInvoiceSetup({ ...dbInvoiceSetup, printer_name: !dbInvoiceSetup?.printer_name ? "0" : dbInvoiceSetup?.printer_name })
      else
        return setInvoiceSetup({ ...DEFAULT_INVOICE_SETUP, brand_uuid })

      let url = `https://api.myfooddo.com/logos/${brand_uuid}.jpeg`
      const res = await fetch(url, {
        headers: {
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0',
        },
      })
      if (res.ok) setImageSRC(url);
    };
    getData();
  }, []);

  const getPrinterData = () => {
    axios({ method: "get", url: "http://127.0.0.1:7878/printers" })
      .then((res) => {
        setPrinters(res.data);
        console.log(res.data)
      })
      .catch((err) => console.log(err));
  };

  const handleChange = (event) => {
    const getValue = (e) => (e.type === "checkbox" ? e.checked : e.value);
    const getSelectedValues = (e) =>
      [...e.options].filter((e) => e.selected).map((e) => e.value);

    const value = event.target.multiple
      ? getSelectedValues(event.target)
      : getValue(event.target);

    const name = event.target.name;
    const isMessage = Object.keys(MESSAGE_LINES).includes(name);
    const isNumber = Object.keys(MAX_CHARS).includes(name);
    const isPayment = name === "payment_modes";
    const constrainedValue = isMessage
      ? constrainLineLengths(value, ...MESSAGE_LINES[name])
      : isNumber
        ? constrainLength(String(value), MAX_CHARS[name])
        : isPayment
          ? [...new Set(value), "0"] // always include "Cash on Delivery"
          : value;

    setInvoiceSetup({
      ...invoiceSetup,
      field_values: {
        ...invoiceSetup.field_values,
        [event.target.name]: constrainedValue,
      },
    });
  };

  // On setup submit
  const handleSubmit = async (event) => {

    event.preventDefault();
    const logo = document.querySelector('#brand_logo_input')?.files?.[0]
    console.log(logo);

    if (logo) {
      const form = new FormData();
      form.append("brand_logo", logo);
      console.log(brand_uuid)

      if (brand_uuid) {

        const call = url => fetch(`${url}/upload_logo/${brand_uuid}`, {
          method: "POST",
          body: form,
        })
          // .then(res => console.log(res))
          .catch(error => {
            console.error("Couldn't upload logo", error)
          })

        servers.forEach(call)
      }
      else
        console.error("No brands found in ")
    }

    const db = await openDB('FoodDo', +localStorage.getItem('IDBVersion') || 1);
    const outletStore = db.transaction("outlet", "readwrite").objectStore("outlet");
    const outlet = (await outletStore.getAll())[0];
    const invoice_setup = await outlet.invoice_setup?.filter(i => i.brand_uuid !== brand_uuid)
    await invoice_setup.push({ ...invoiceSetup })
    const updatedValue = await { ...outlet, invoice_setup }

    await outletStore.put(updatedValue);
    handleInvoiceUnsyncedFile(updatedValue);
    onSave();
  };

  // Adding/Editing  outlet details to unsynced_files collection in IndexedDB
  const handleInvoiceUnsyncedFile = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db.transaction("unsynced_files", "readwrite").objectStore("unsynced_files");
    const ndata = {
      IDENTIFIER: "invoice_setup",
      RECON_TIME: Date.now(),
      invoice_setup: data.invoice_setup,
    };
    await tx.put(ndata);
    handleInvoiceReconciliation(ndata);
    updateUnSync()
  };

  // Adding/Editing invoice to reconciliation collection in IndexedDB
  const handleInvoiceReconciliation = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db.transaction("reconciliation", "readwrite").objectStore("reconciliation");
    const allReconRecords = await tx.getAll();

    const othersJsonExists = allReconRecords.find((curr) => curr.IDENTIFIER === "others");
    if (othersJsonExists) {
      const invoice = othersJsonExists?.details?.filter((entry) => entry.type !== 'invoice_setup')
      const editData = {
        ...othersJsonExists,
        details: [
          ...invoice,
          {
            type: 'invoice_setup',
            RECON_TIME: data.RECON_TIME,
          },
        ],
      };
      await tx.put(editData)
    } else {
      const newdata = {
        IDENTIFIER: "others",
        details: [
          {
            type: 'invoice_setup',
            RECON_TIME: data.RECON_TIME,
          },
        ]
      };
      await tx.add(newdata);
    }
  }

  const [imageSRC, setImageSRC] = useState('')
  const onImageSelect = async e => {
    if (e.target.files?.[0]) {
      let imageUrl = await URL.createObjectURL(e.target.files[0])
      console.log(imageUrl)
      setImageSRC(imageUrl);
    }
  }

  const deleteImage = async e => {

    e.preventDefault();
    const showWarning = (warning) => {
      clearInterval(sessionStorage.getItem("notification-warning-timeout"));
      document.querySelector(".notification-message").innerText = warning.message;
      document.querySelector(".notification-container").classList.add(warning.color);
      const timeoutId = setTimeout(() => document.querySelector(".notification-container").classList.remove(warning.color), 2000);
      sessionStorage.setItem("notification-warning-timeout", timeoutId);
    }

    console.log('delete function called')
    console.log(brand_uuid)

    if (brand_uuid) {

      servers.forEach(url =>
        fetch(`${url}/delete_logo/${brand_uuid}`, { method: "delete" })
          .then(res => {

            if (res.status === 404)
              return showWarning({
                message: 'No image found for this item',
                color: 'active-red'
              })

            else if (!res.ok)
              return showWarning({
                message: 'Failed to delete the image',
                color: 'active-red'
              })

            showWarning({
              message: 'Image deleted successfully',
              color: 'active-green'
            })

            setImageSRC(null)
          })
          .catch(error => {
            console.error("Couldn't delete logo", error)
          })
      )
    }
    else
      console.error("No brands found in ")
  }

  return (
    <>
      <form className={styles.form} onSubmit={handleSubmit}>
        <div className={styles.heading}>
          <h1>Invoice Setup</h1>
        </div>

        <div className={styles.formContainer}>
          <div id={styles.top_content}>
            <button
              type="button"
              className={`${styles.fieldCustomizationButton} ${styles.bottom_cover}`}
              onClick={() => setCustomizationModalOpen(true)}
            >
              Field customization
            </button>

            <div>
              <label htmlFor="brand_logo_input">
                {imageSRC ?
                  <img
                    src={imageSRC}
                    className={styles.brand_invoice_logo}
                    alt='item'
                    width='128'
                    height='128'
                  />
                  :
                  <span>Select Your Brand Logo</span>
                }
                <input type="file" name="brand_logo" id="brand_logo_input" accept="image/*" style={{ display: "none" }} onChange={onImageSelect} />
              </label>
              {imageSRC && <DeleteOutlinedIcon id={styles.delete_logo} onClick={deleteImage} />}
            </div>
          </div>

          <div className={styles.formGroup}>
            <h2>General Details</h2>

            <div className={styles.row}>
              <label className={styles.selectLabel}>
                Invoice Heading
                <input
                  type="text"
                  name="invoice_heading"
                  className={styles.numberInput}
                  value={invoiceSetup?.field_values?.invoice_heading}
                  onChange={(e) => handleChange(e)}
                />
              </label>

              <label className={styles.selectLabel}>
                Invoice Brand Title
                <input
                  type="text"
                  name="invoice_title"
                  className={styles.numberInput}
                  value={invoiceSetup?.field_values?.invoice_title}
                  onChange={(e) => handleChange(e)}
                />
              </label>
            </div>

            <div className={styles.row}>
              <label className={styles.selectLabel}>
                Phone Number
                <textarea
                  name="invoice_phone"
                  className={styles.messageTextarea}
                  value={invoiceSetup?.field_values?.invoice_phone}
                  onChange={(e) => handleChange(e)}
                />
              </label>

              <label className={styles.selectLabel}>
                Address
                <textarea
                  name="invoice_address"
                  className={styles.messageTextarea}
                  value={invoiceSetup?.field_values?.invoice_address}
                  onChange={(e) => handleChange(e)}
                />
              </label>
            </div>

            <div className={styles.row}>
              <label className={styles.selectLabel}>
                Blank lines
                <textarea
                  name="invoice_blank"
                  className={styles.messageTextarea}
                  value={invoiceSetup?.field_values?.invoice_blank}
                  onChange={(e) => handleChange(e)}
                />
              </label>

              <label className={styles.selectLabel}>
                Bottom Row
                <textarea
                  name="invoice_bottomnote"
                  className={styles.messageTextarea}
                  value={invoiceSetup?.field_values?.invoice_bottomnote}
                  onChange={(e) => handleChange(e)}
                />
              </label>
            </div>
          </div>

          <div className={styles.formGroup}>
            <h2>Printer Setup</h2>

            <div className={styles.row}>
              <label className={styles.selectLabel}>
                Select printer
                <select
                  name="page_type"
                  className={styles.select}
                  value={invoiceSetup?.printer_name}
                  onClick={printers?.[0] ? e => e.currentTarget?.focus() : getPrinterData}
                  onChange={(e) =>
                    setInvoiceSetup({
                      ...invoiceSetup,
                      printer_name: e.target.value,
                    })
                  }
                >
                  {+invoiceSetup?.printer_name === 0 || invoiceSetup?.printer_name === "" ? <option value='0'>
                    Browser Printer
                  </option> : <>
                    <option value={invoiceSetup?.printer_name} selected>

                      {+invoiceSetup?.printer_name === 0 ? "Browser Printer" : invoiceSetup?.printer_name}
                    </option>
                    <option value='0'>Browser Printer</option>
                  </>

                  }

                  {printers?.filter(a => a.name !== invoiceSetup.printer_name)
                    .map((item) => (
                      <option key={item.deviceId} value={item.deviceId}>
                        {item.name}
                      </option>
                    ))}
                </select>
              </label>
              <button
                type="button"
                className={styles.fieldCustomizationButton}
                onClick={() => setPageConfigurationModalOpen(true)}
              >
                Page Configuration
              </button>
            </div>
          </div>
          <button type="submit" className={styles.fieldCustomizationButton} style={{ background: '#44cd4a' }}>
            Save changes
          </button>
        </div>
      </form>
      {
        customizationModalOpen && (
          <SetupModal onClose={() => setCustomizationModalOpen(false)}>
            <InvoiceFieldCustomizationForm
              brand_uuid={brand_uuid}
              invoiceSetup={invoiceSetup}
              invoiceFieldCustomization={invoiceSetup.invoice_field_customization}
              setCustomizationModalOpen={setCustomizationModalOpen}
              setInvoiceFieldCustomization={(newInvoiceFieldCustomization) =>
                setInvoiceSetup({
                  ...invoiceSetup,
                  invoice_field_customization: newInvoiceFieldCustomization,
                })
              }
            />
          </SetupModal>
        )
      }
      {
        pageConfigurationModalOpen && (
          <SetupModal onClose={() => setPageConfigurationModalOpen(false)}>
            <PageConfigurationForm
              setPageConfigurationModalOpen={setPageConfigurationModalOpen}
              invoiceSetup={invoiceSetup}
              setInvoiceSetup={setInvoiceSetup}
            />
          </SetupModal>
        )
      }
    </>
  );
}
